import Field from '../Field.jsx';
import FieldGroup from '../FieldGroup.jsx';
import { SumToOneBar } from './primitives.jsx';

export default function PointsSection({ points, set }) {
  const setP = (field, value) => set(`points.${field}`, value);
  return (
    <div className="space-y-5">
      <FieldGroup
        title="Earn rate by category"
        caption="Multiplier per $1 spent in each MCC bucket"
      >
        <Field
          label="Online"
          value={points.earnRateByCategory.online}
          step={0.5}
          onChange={(v) => setP('earnRateByCategory.online', v)}
        />
        <Field
          label="In-store"
          value={points.earnRateByCategory.inStore}
          step={0.5}
          onChange={(v) => setP('earnRateByCategory.inStore', v)}
        />
        <Field
          label="Stablecoin-funded"
          value={points.earnRateByCategory.stablecoinFunded}
          step={0.5}
          onChange={(v) => setP('earnRateByCategory.stablecoinFunded', v)}
        />
        <Field
          label="Default"
          value={points.earnRateByCategory.default}
          step={0.5}
          onChange={(v) => setP('earnRateByCategory.default', v)}
        />
        <Field
          label="ATM"
          value={points.earnRateByCategory.atm}
          step={0.5}
          onChange={(v) => setP('earnRateByCategory.atm', v)}
        />
      </FieldGroup>

      <FieldGroup title="Redemption mix" caption="Shares must sum to 1.0">
        <Field
          label="Subscription waiver"
          value={points.redemptionMix.subWaiver}
          pct
          step={0.01}
          onChange={(v) => setP('redemptionMix.subWaiver', v)}
        />
        <Field
          label="Marketplace"
          value={points.redemptionMix.marketplace}
          pct
          step={0.01}
          onChange={(v) => setP('redemptionMix.marketplace', v)}
        />
        <Field
          label="Crypto"
          value={points.redemptionMix.crypto}
          pct
          step={0.01}
          onChange={(v) => setP('redemptionMix.crypto', v)}
        />
        <Field
          label="USD cash"
          value={points.redemptionMix.usdCash}
          pct
          step={0.01}
          onChange={(v) => setP('redemptionMix.usdCash', v)}
        />
        <div className="px-4 py-3">
          <SumToOneBar values={points.redemptionMix} label="Mix sum" />
        </div>
      </FieldGroup>

      <FieldGroup
        title="Cost per redemption"
        caption="Real USD cost to Pulsar per point in each path"
      >
        <Field
          label="Subscription waiver · key calibration lever"
          value={points.costPerRedemption.subWaiver}
          step={0.0001}
          decimals={4}
          onChange={(v) => setP('costPerRedemption.subWaiver', v)}
        />
        <Field
          label="Marketplace"
          value={points.costPerRedemption.marketplace}
          step={0.0001}
          decimals={4}
          onChange={(v) => setP('costPerRedemption.marketplace', v)}
        />
        <Field
          label="Crypto"
          value={points.costPerRedemption.crypto}
          step={0.0001}
          decimals={4}
          onChange={(v) => setP('costPerRedemption.crypto', v)}
        />
        <Field
          label="USD cash"
          value={points.costPerRedemption.usdCash}
          step={0.0001}
          decimals={4}
          onChange={(v) => setP('costPerRedemption.usdCash', v)}
        />
      </FieldGroup>

      <FieldGroup title="General">
        <Field
          label="Point face value ($)"
          value={points.pointFaceValue}
          step={0.001}
          decimals={3}
          onChange={(v) => setP('pointFaceValue', v)}
        />
        <Field
          label="Breakage rate"
          value={points.breakageRate}
          pct
          step={0.01}
          onChange={(v) => setP('breakageRate', v)}
        />
      </FieldGroup>
    </div>
  );
}
